import { Space } from "antd";
import React from "react";
import TmsPrasadamService from "../../../services/tms-prasadam.service";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import {
  EditOutlined,
  EyeOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../constants/tms-route.map";

const TmsPrasadaminnerActions = ({
  record,
  setLoading,
  setViewPrasadamData,
  settmsModalVisible,
  // eslint-disable-next-line no-unused-vars
  setUpdateFlag,
  setEditFlag,
  setProductId,
  router,
  setShowDrawer,
  setTermsData,
  setOnlineTermsData,
}) => {
  return (
    <Space size="middle">
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.smd_prasadam_manage_counter}?id=${record.key}&name=${record?.name}`
          );
        }}
      >
        Manage POS
      </a>
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const data = await TmsPrasadamService.viewPrasadam(record?.key);
            // console.log(darData);
            setViewPrasadamData(data);
            settmsModalVisible(true);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EyeOutlined />
      </a>
      {/* <Popconfirm
        title="Are you sure delete this prasadam?"
        onConfirm={async () => {
          setLoading(true);
          try {
            await TmsPrasadamService.deletePrasadam(record?.key);
            notification.success({
              message: "Prasadam Deleted Successful",
            });
            setUpdateFlag(Math.Random + 1);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
        okText="Yes"
        cancelText="No"
      >
        <a>
          <DeleteOutlined />
        </a>
      </Popconfirm> */}
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsPrasadamService.viewPrasadam(record?.key);
            setViewPrasadamData(darData);
            settmsModalVisible(true);
            setEditFlag(true);
            setProductId(record?.key);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EditOutlined />
      </a>
      <a
        onClick={() => {
          setShowDrawer(true);
          setProductId(record?.key);
          setTermsData(record?.metadata?.termsAndConditions);
          setOnlineTermsData(record?.metadata?.onlineTermsAndConditions);
        }}
      >
        <FileProtectOutlined />
      </a>
    </Space>
  );
};
export default withRouter(TmsPrasadaminnerActions);
